import React from 'react'
import { Helmet } from 'react-helmet';


const Page404 = () => <>
    <Helmet>
        <title>Page Not Found | Sparkling Email</title>
    </Helmet>
    <section
        className="d-flex flex-column align-items-center justify-content-center text-center bg-light text-dark py-5"
        style={{ minHeight: '60vh' }}
    >
        <h1>Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        <div className="row text-center">
            <a href="/" className="btn btn-warning btn-lg mt-3">
                Back to Sparkling Email Homepage
            </a>
        </div>
    </section>
</>


export default Page404;